/**
 * AdminTestimonials — manage customer testimonials shown on home page.
 */
import AdminCrudPage from "./AdminCrudPage";

const fields = [
  { name: "name", label: "Customer Name", type: "text" },
  { name: "company", label: "Company", type: "text" },
  { name: "role", label: "Role / Designation", type: "text" },
  { name: "photo", label: "Customer / Company Photo (round frame)", type: "image" },
  { name: "quote", label: "Testimonial Quote", type: "textarea", rows: 5 },
  { name: "rating", label: "Star Rating (1-5)", type: "number" },
  { name: "order", label: "Display Order (lower = first)", type: "number" },
  { name: "visible", label: "Visible on site", type: "boolean" },
];

const columns = [
  { key: "name", label: "Name" },
  { key: "company", label: "Company" },
  { key: "role", label: "Role" },
  { key: "order", label: "Order" },
  { key: "visible", label: "Visible", render: (it) => (it.visible ? "Yes" : "No") },
];

export default function AdminTestimonials() {
  return (
    <AdminCrudPage
      title="Testimonials"
      endpoint="testimonials"
      columns={columns}
      fields={fields}
      initial={{ name: "", company: "", role: "", photo: "", quote: "", rating: 5, order: 0, visible: true }}
    />
  );
}
